import React from 'react';
import { QaRubric } from '../components/qa/QaRubric';
export function Qa() {
  const pendingReviews = [{
    id: 1,
    lead: 'La Tasquita de Enfrente',
    setter: 'Carlos M.',
    reason: '10% Semanal',
    date: 'Hoy'
  }, {
    id: 2,
    lead: 'Bar Manolo',
    setter: 'Ana P.',
    reason: 'Rechazado',
    date: 'Ayer'
  }];
  return <div className="p-4 md:p-8 max-w-[1100px] mx-auto space-y-6 pb-24 md:pb-8" data-id="element-767">
      <div className="flex items-center justify-between" data-id="element-768">
        <div data-id="element-769">
          <h1 className="text-[28px] font-bold text-growthly-text" data-id="element-770">
            Quality Assurance
          </h1>
          <p className="text-[13px] text-growthly-muted mt-1" data-id="element-771">
            Auditoría de llamadas y mensajes.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-772">
        <div className="lg:col-span-1" data-id="element-773">
          <div className="card overflow-hidden" data-id="element-774">
            <div className="p-4 border-b border-white/5 bg-growthly-panel" data-id="element-775">
              <h3 className="text-[14px] font-semibold text-growthly-text" data-id="element-776">
                Pendientes de Revisión
              </h3>
            </div>
            <div className="divide-y divide-white/5" data-id="element-777">
              {pendingReviews.map((review, idx) => <div key={review.id} className={`p-4 cursor-pointer transition-colors ${idx === 0 ? 'bg-white/5 border-l-2 border-l-growthly-amber' : 'hover:bg-white/[0.02]'}`} data-id="element-778">
                  <div className="flex justify-between items-start mb-1" data-id="element-779">
                    <span className="text-[14px] font-medium text-growthly-text" data-id="element-780">
                      {review.lead}
                    </span>
                    <span className="text-[11px] text-growthly-muted" data-id="element-781">
                      {review.date}
                    </span>
                  </div>
                  <div className="flex justify-between items-center text-[12px]" data-id="element-782">
                    <span className="text-growthly-muted" data-id="element-783">{review.setter}</span>
                    <span className="bg-white/10 px-2 py-0.5 rounded text-growthly-text" data-id="element-784">
                      {review.reason}
                    </span>
                  </div>
                </div>)}
            </div>
          </div>
        </div>

        <div className="lg:col-span-2" data-id="element-785">
          <QaRubric leadName="La Tasquita de Enfrente" setterName="Carlos M." data-id="element-786" />
        </div>
      </div>
    </div>;
}